<template>
  <div class="container">
    <div class="weui-navbar daojia-navbar">
        <div class="daojia-navbar-left"><span class="icon-chevron-left" @click="goback()"></span></div>

        <div class="daojia-navbar-left" v-show="$route.query.back" @click="$router.go(-1)"><span class="icon-chevron-left"></span></div>
        <h1 class="daojia-navbar-middle daojia-navbar-middle_logo"><a href="#"><img src="../../assets/img/global/logo.png"></a></h1>
        <div class="daojia-navbar-right">
        </div>
    </div>
    <div class="image-box">
        <img v-if="order.data.student_plan=='1668743923'" src='/static/img/storage/Mini.jpg'>
        <img v-if="order.data.student_plan=='1668743953'" src='/static/img/storage/A.jpg'>
        <img v-if="order.data.student_plan=='1668743985'" src='/static/img/storage/B.jpg'>
        <img v-if="order.data.student_plan=='1668744048'" src='/static/img/storage/C.jpg'>
        <img src='/static/img/storage/A_02.png'>
        <img src='/static/img/storage/A_03.jpg'>
        <img src='/static/img/storage/A_04.jpg'>
        <img src='/static/img/storage/A_05.jpg'>
        <img src='/static/img/storage/A_06.jpg'>
        <img src='/static/img/storage/A_07.jpg'>
    </div>
    <div class="js_dialog" v-show="isLeaving">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">订单尚未完成</strong></div>
            <div class="weui-dialog__bd">确定要回到首页吗？回去后将丢失当前下单进度</div>
            <div class="weui-dialog__ft">
                <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isLeaving=false">取消</div>
                <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="goto('/')">回到首页</div>
            </div>
        </div>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">

        <a href="javascript:void(0)" class="btn active" @click="goto('/storage-step3') ">立即预约</a>
      </div>
    </div>
    <img :src="pixelURL('cangchu','taocanjieshao')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'work',
  data () {
    return {
      isLeaving:false,
      order:{}
    }
  },
  methods: {
    goback(){
      this.$router.push('/storage-step2')
    },
  },
  computed: {
    workingHours: function () {
      let d = new Date();
      let time = d.getHours();
      return time;
    }
  },
  components: {
  },
  created: function () {
    if (localStorage.order) {
        let localParsed = JSON.parse(localStorage.order);
        this.order = localParsed;
    }
    else{
      //this.$router.push('/');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:50px;
}

.title{
  font-size:1.4em;
}
.empty{
  padding:0 20vw;
  text-align:center;
  margin-top:2vh;
  width:100vw;
  box-sizing:border-box;
  color:#999;
  a{
    color:#fe9567;
  }
}
.image-box{
  img{
    width:100%;
  }
  font-size:0;
}
.btn{
  margin-top:20px;
}
.text{
  text-align:center;
  font-size:1.2em;
  color:#888;
}

.slogan{
  margin-top:6px;
  margin-bottom:5px;
  font-size:0.8em;
}


.daojia-navbar {
    position: fixed;
    background: rgba(255, 255, 255, 0.95);
    padding: 8px 10px;
    box-sizing: border-box;
    height: 50px;
}

.daojia-navbar-left {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: left;
    span{
      font-size: 2em;
      color: #666;
    }
}

.daojia-navbar-middle_logo img{
    height:34px;
}

.daojia-navbar-middle {
    display: block;
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
    font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.2em;
    line-height: 1.3;
    font-weight: bold;
}

.daojia-navbar-right {
    font-size: 14px;
    line-height: 26px;
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/pages/storage/intro.vue